import {forwardRef} from "react";
import Flex from "./Flex.jsx";

const FlexColumn = forwardRef(({ fullWidth, ...props }, ref) => {
  return <Flex flexDirection="column" ref={ref} fullWidth={fullWidth !== false} {...props} />;
});

export default FlexColumn;
